import React, { useEffect, useReducer, useState } from 'react';
import CountUp from "react-countup";
import { Link } from 'react-router-dom';
import { Card, CardBody, Col } from 'reactstrap';
import { ecomWidgets } from "../../common/data";
import { getAPIStatus, getUserStatus } from '../../helpers/fakebackend_helper';
import { useStore } from 'react-redux';
import moment from 'moment';

const Widgets = () => {
    const [currentUser, setCurrentUser] = useState({ sub_credit_remain: 0, bought_credit: 0 })
    const [apiStatus, setApiStatus] = useState({ total: 0, total_success: 0, total_failed: 0, total_processing: 0 })
    const loginUser = useStore().getState().Login
    useEffect(() => {
        if (loginUser.user) {

            loadData()
            loadAPIStatus()
        }
    }, [loginUser])
    const loadAPIStatus = async () => {
        const response = await getAPIStatus(moment().subtract(1, "year").toISOString(), moment().toISOString())
        if(response.success){
            setApiStatus(response.data[0])
        }
        // console.log(response)
    }
    const loadData = async () => {

        const userResponse = await getUserStatus();
        setCurrentUser(userResponse.data)
    }
    return (
        <React.Fragment>
            <Col xl={3} md={6} >
                <Card className="card-animate">
                    <CardBody>
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1 overflow-hidden">
                                <p className="text-uppercase fw-medium text-muted text-truncate mb-0">Remain credit</p>
                            </div>
                            <div className="flex-shrink-0">
                                {/* <h5 className={"fs-14 mb-0 text-" + item.badgeClass}>
                                        {item.badge ? <i className={"fs-13 align-middle " + item.badge}></i> : null} {item.percentage} %
                                    </h5> */}
                            </div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-4">
                            <div>
                                <h4 className="fs-22 fw-semibold ff-secondary mb-4"><span className="counter-value" data-target="559.25">
                                    <CountUp
                                        start={0}
                                        // prefix={item.prefix}
                                        // suffix={item.suffix}
                                        // separator={item.separator}
                                        end={(currentUser.sub_credit_remain || 0) + (currentUser.bought_credit || 0)}
                                        // decimals={item.decimals}
                                        duration={4}
                                    />
                                </span></h4>
                                {/* <Link to="#" className="text-decoration-underline">{item.link}</Link> */}
                            </div>
                            <div className="avatar-sm flex-shrink-0">
                                <span className={"avatar-title rounded fs-3 bg-info-subtle"}>
                                    <i className={`text-info bx bx-wallet`}></i>
                                </span>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
            <Col xl={3} md={6} >
                <Card className="card-animate">
                    <CardBody>
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1 overflow-hidden">
                                <p className="text-uppercase fw-medium text-muted text-truncate mb-0 ">Success API call</p>
                            </div>
                            <div className="flex-shrink-0">
                                {/* <h5 className={"fs-14 mb-0 text-" + item.badgeClass}>
                                        {item.badge ? <i className={"fs-13 align-middle " + item.badge}></i> : null} {item.percentage} %
                                    </h5> */}
                            </div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-4">
                            <div>
                                <h4 className="fs-22 fw-semibold ff-secondary mb-4"><span className="counter-value text-success" >
                                    <CountUp
                                        start={0}
                                        // prefix={item.prefix}
                                        // suffix={item.suffix}
                                        // separator={item.separator}
                                        end={apiStatus.total_success}
                                        // decimals={item.decimals}
                                        duration={4}
                                    />
                                </span></h4>
                                {/* <Link to="#" className="text-decoration-underline">{item.link}</Link> */}
                            </div>
                            <div className="avatar-sm flex-shrink-0">
                                <span className={"avatar-title rounded fs-3 bg-success-subtle"}>
                                    <i className={`text-success bx bx-check`}></i>
                                </span>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
            <Col xl={3} md={6} >
                <Card className="card-animate">
                    <CardBody>
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1 overflow-hidden">
                                <p className="text-uppercase fw-medium text-muted text-truncate mb-0">Processing API call</p>
                            </div>
                            <div className="flex-shrink-0">
                                {/* <h5 className={"fs-14 mb-0 text-" + item.badgeClass}>
                                        {item.badge ? <i className={"fs-13 align-middle " + item.badge}></i> : null} {item.percentage} %
                                    </h5> */}
                            </div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-4">
                            <div>
                                <h4 className="fs-22 fw-semibold ff-secondary mb-4"><span className="counter-value text-warning">
                                    <CountUp
                                        start={0}
                                        // prefix={item.prefix}
                                        // suffix={item.suffix}
                                        // separator={item.separator}
                                        end={apiStatus.total_processing}
                                        // decimals={item.decimals}
                                        duration={4}
                                    />
                                </span></h4>
                                {/* <Link to="#" className="text-decoration-underline">{item.link}</Link> */}
                            </div>
                            <div className="avatar-sm flex-shrink-0">
                                <span className={"avatar-title rounded fs-3 bg-warning-subtle"}>
                                    <i className={`text-warning bx bx-refresh`}></i>
                                </span>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
            <Col xl={3} md={6} >
                <Card className="card-animate">
                    <CardBody>
                        <div className="d-flex align-items-center">
                            <div className="flex-grow-1 overflow-hidden">
                                <p className="text-uppercase fw-medium text-muted text-truncate mb-0">Failed API call</p>
                            </div>
                            <div className="flex-shrink-0">
                                {/* <h5 className={"fs-14 mb-0 text-" + item.badgeClass}>
                                        {item.badge ? <i className={"fs-13 align-middle " + item.badge}></i> : null} {item.percentage} %
                                    </h5> */}
                            </div>
                        </div>
                        <div className="d-flex align-items-end justify-content-between mt-4">
                            <div>
                                <h4 className="fs-22 fw-semibold ff-secondary mb-4"><span className="counter-value text-danger">
                                    <CountUp
                                        start={0}
                                        // prefix={item.prefix}
                                        // suffix={item.suffix}
                                        // separator={item.separator}
                                        end={apiStatus.total_failed}
                                        // decimals={item.decimals}
                                        duration={4}
                                    />
                                </span></h4>
                                {/* <Link to="#" className="text-decoration-underline">{item.link}</Link> */}
                            </div>
                            <div className="avatar-sm flex-shrink-0">
                                <span className={"avatar-title rounded fs-3 bg-danger-subtle"}>
                                    <i className={`text-danger bx bx-error-alt`}></i>
                                </span>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default Widgets;